import { signInWithEmailAndPassword } from "firebase/auth";
import { useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Credentials, Submission } from "../../types/authTypes";
import { auth } from "../../config/firebaseConfig";
import logo from "../../assets/images/logo.png";
import { signOutUser } from "../../hooks/firebase/signOut";
import SignInForm from "../../components/forms/Signin.form";

import messageBox from "../../assets/components/message/MessageBox";

const SignIn = () => {
  const [credentials, setCredentials] = useState<Credentials>({
    email: "",
    password: "",
  });

  const signIn = async (e: Submission) => {
    e.preventDefault();
    if (credentials.email !== "" && credentials.password !== "") {
      try {
        await signInWithEmailAndPassword(
          auth,
          credentials.email,
          credentials.password
        );
      } catch (error) {
        console.log(error);
        signOutUser();
        messageBox({
          message: "Inloggen mislukt",
          type: "error",
        });
      }
    }
  };

  const loading = false;

  return (
    <Container
      fluid
      className="p-5 vh-100"
      style={{ backgroundColor: "#f6f7fb" }}
    >
      <Row
        className="rounded d-flex flex-column justify-content-center align-items-center"
        style={{ marginTop: "10%" }}
      >
        <Col
          xs={12}
          className="signin-card d-flex flex-column shadow  align-self-center rounded-3 justify-content-center"
          style={{ maxWidth: "500px", backgroundColor: "#374558" }}
        >
          <Image
            src={logo}
            style={{ maxWidth: "80%" }}
            className="align-self-center mt-2 pt-4 mb-2  "
          />
          <SignInForm
            signIn={signIn}
            credentials={credentials}
            setCredentials={setCredentials}
            loading={loading}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default SignIn;
